import { createSelector } from '@reduxjs/toolkit';
import { SecurityTypesUtils, type Security } from '@talos/kyoko';
import { Option } from '../../../../../components/OMS/NewOrder/models';
import { getRFQOptionModelRefData } from '../../../../../components/OMS/NewRFQ/RFQSlice';
import type { OMSReferenceDataState } from '../../../../../components/OMS/types';

const selectOptionModelRefData = createSelector(
  (referenceData: OMSReferenceDataState) => referenceData,
  getRFQOptionModelRefData
);

let cachedOptionModelRefData: ReturnType<typeof getRFQOptionModelRefData> | undefined;
let primeabilityBySymbol = new Map<string, boolean>();

// Cached per referenceData identity — uncached, this would redo full resolution on every scroll remount.
export function isOptionPrimeable(referenceData: OMSReferenceDataState, security: Security): boolean {
  const optionModelRefData = selectOptionModelRefData(referenceData);
  if (optionModelRefData !== cachedOptionModelRefData) {
    cachedOptionModelRefData = optionModelRefData;
    primeabilityBySymbol = new Map();
  }

  const cached = primeabilityBySymbol.get(security.Symbol);
  if (cached != null) {
    return cached;
  }

  const result = SecurityTypesUtils.Option.isType(security) && Option.canResolve(optionModelRefData, security);
  primeabilityBySymbol.set(security.Symbol, result);
  return result;
}
